// form
import { FormProvider as Form, UseFormReturn } from 'react-hook-form';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
  methods: UseFormReturn<any>;
  onSubmit?: VoidFunction;
  preventKeyPress?: boolean;
};

export default function FormProvider({
  children,
  onSubmit,
  methods,
  preventKeyPress,
}: Props) {
  return (
    <Form {...methods}>
      <form
        onSubmit={onSubmit}
        onKeyDown={(e) =>
          (e.key === 'Enter' || e.key === 'NumpadEnter') && preventKeyPress
            ? e.preventDefault()
            : undefined
        }
      >
        {children}
      </form>
    </Form>
  );
}
